<template>
  <div class="modal fade" :class="{ 'show d-block': visible }" ref="mdlAsignarCliente" data-bs-backdrop="static"
    data-bs-keyboard="false" tabindex="-1" role="dialog"
    :style="visible ? 'display: block; background: rgba(0, 0, 0, 0.55); z-index: 1060;' : ''" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content shadow border-0">
        <!-- Modal Header -->
        <div class="modal-header bg-success text-white py-3">
          <div class="d-flex align-items-center">
            <i class="mdi mdi-account-arrow-right font-size-22 me-2"></i>
            <div>
              <h5 class="modal-title text-white mb-0 font-size-16">
                Asignar número a cliente
              </h5>
              <small class="text-white-50">
                Teléfono: {{ telefonoMostrar }}
              </small>
            </div>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="cerrar" aria-label="Cerrar"
            :disabled="asignando"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-4">
          <!-- Alerta informativa -->
          <div class="alert alert-info d-flex align-items-center mb-3 py-2 px-3 font-size-13" role="alert">
            <i class="mdi mdi-information-outline font-size-18 me-2"></i>
            <div>
              Busque y seleccione el cliente al que desea asignar este número telefónico.
            </div>
          </div>

          <!-- Buscador de clientes -->
          <div class="mb-3">
            <label class="form-label font-size-13 fw-semibold text-secondary">
              Buscar cliente (Nombre, apellido, ID o número de cliente)
            </label>
            <div class="input-group">
              <span class="input-group-text bg-light border-end-0">
                <i class="mdi mdi-magnify text-muted font-size-16"></i>
              </span>
              <input type="text" class="form-control border-start-0"
                placeholder="Escribe el nombre, ID o teléfono del cliente y presiona Buscar..."
                v-model="criterioBusqueda" @keyup.enter="buscarClientes(1)" :disabled="cargando || asignando"
                ref="inputBusqueda" />
              <button class="btn btn-primary px-3" type="button" @click="buscarClientes(1)"
                :disabled="cargando || asignando">
                <span v-if="cargando" class="spinner-border spinner-border-sm me-1" role="status"></span>
                <i v-else class="mdi mdi-magnify me-1"></i>
                Buscar
              </button>
            </div>
          </div>

          <!-- Tabla de resultados -->
          <div class="table-responsive rounded border mb-3" style="max-height: 340px; min-height: 180px;">
            <table class="table table-hover align-middle mb-0 font-size-13">
              <thead class="table-light sticky-top">
                <tr>
                  <th style="width: 70px;">ID</th>
                  <th>Cliente</th>
                  <th style="width: 130px;">No. Cliente</th>
                  <th style="width: 100px;" class="text-center">Estado</th>
                  <th style="width: 120px;" class="text-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="cargando">
                  <td colspan="5" class="text-center py-5 text-muted">
                    <span class="spinner-border spinner-border-sm text-primary me-2"></span>
                    Buscando clientes...
                  </td>
                </tr>

                <tr v-else-if="clientes.length === 0 && busquedaRealizada">
                  <td colspan="5" class="text-center py-5 text-muted">
                    <i class="mdi mdi-account-search-outline font-size-36 d-block mb-1 text-secondary"></i>
                    No se encontraron clientes con el criterio "{{ criterioBusqueda }}".
                  </td>
                </tr>

                <tr v-else-if="clientes.length === 0 && !busquedaRealizada">
                  <td colspan="5" class="text-center py-5 text-muted">
                    <i class="mdi mdi-account-search font-size-36 d-block mb-1 text-secondary"></i>
                    Ingrese un nombre o dato de cliente y presione <strong>Buscar</strong>.
                  </td>
                </tr>

                <tr v-for="item in clientes" :key="item.id"
                  :class="{ 'table-success': clienteSeleccionado && clienteSeleccionado.id === item.id }">
                  <td class="fw-semibold text-muted">#{{ item.id }}</td>
                  <td>
                    <div class="fw-semibold text-dark">
                      {{ item.nombre_completo || obtenerNombreCompleto(item) }}
                    </div>
                    <small class="text-muted" v-if="item.correo || item.telefono">
                      {{ item.correo || '' }}
                      <span v-if="item.correo && item.telefono"> • </span>
                      {{ item.telefono || '' }}
                    </small>
                  </td>
                  <td>
                    <span class="badge bg-light text-dark font-size-12 border">
                      {{ item.numero || item.id }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="badge"
                      :class="item.activo ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'">
                      {{ item.activo ? 'Activo' : 'Inactivo' }}
                    </span>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-sm btn-outline-success d-inline-flex align-items-center"
                      :disabled="asignando" @click="seleccionarYAsignar(item)">
                      <i class="mdi mdi-check-bold me-1"></i>
                      Asignar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginador simple si hay resultados -->
          <div v-if="totalPaginas > 1"
            class="d-flex justify-content-between align-items-center font-size-12 text-muted px-1">
            <span>Página {{ paginaActual }} de {{ totalPaginas }} ({{ totalRegistros }} clientes)</span>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-light" :disabled="paginaActual <= 1 || cargando"
                @click="buscarClientes(paginaActual - 1)">
                <i class="mdi mdi-chevron-left"></i> Anterior
              </button>
              <button class="btn btn-light" :disabled="paginaActual >= totalPaginas || cargando"
                @click="buscarClientes(paginaActual + 1)">
                Siguiente <i class="mdi mdi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer bg-light py-2">
          <button type="button" class="btn btn-secondary font-size-13" @click="cerrar" :disabled="asignando">
            <i class="mdi mdi-close me-1"></i>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "bootstrap/js/dist/modal";
import Swal from "sweetalert2";
import ClienteSrv from "@/services/ClienteSrv.js";
import WhatsappSrv from "@/services/WhatsappSrv.js";

export default {
  name: "MdlAsignarClienteWhatsapp",
  emits: ["cliente-asignado"],
  data() {
    return {
      modalInstancia: null,
      visible: false,
      chat: null,
      criterioBusqueda: "",
      clientes: [],
      cargando: false,
      asignando: false,
      busquedaRealizada: false,
      clienteSeleccionado: null,
      paginaActual: 1,
      totalPaginas: 1,
      totalRegistros: 0,
      porPagina: 10
    };
  },
  computed: {
    telefonoMostrar() {
      if (!this.chat) return "";
      const pref = this.chat.prefijo ? `${this.chat.prefijo} ` : "";
      return `${pref}${this.chat.numero || ""}`.trim();
    }
  },
  mounted() {
    if (this.$refs.mdlAsignarCliente) {
      try {
        this.modalInstancia = new Modal(this.$refs.mdlAsignarCliente);
      } catch (e) { }
    }
  },
  methods: {
    abrir(chat) {
      this.mostrar(chat);
    },

    mostrar(chat) {
      this.chat = chat || null;
      this.criterioBusqueda = "";
      this.clientes = [];
      this.busquedaRealizada = false;
      this.clienteSeleccionado = null;
      this.paginaActual = 1;
      this.totalPaginas = 1;
      this.totalRegistros = 0;
      this.visible = true;

      if (!this.modalInstancia && this.$refs.mdlAsignarCliente) {
        try {
          this.modalInstancia = new Modal(this.$refs.mdlAsignarCliente);
        } catch (e) { }
      }
      if (this.modalInstancia) {
        try {
          this.modalInstancia.show();
        } catch (e) { }
      }

      this.$nextTick(() => {
        if (this.$refs.inputBusqueda) {
          this.$refs.inputBusqueda.focus();
        }
        // Cargar primeros 10 clientes por defecto para que no aparezca vacío
        this.buscarClientes(1);
      });
    },

    cerrar() {
      this.visible = false;
      if (this.modalInstancia) {
        try {
          this.modalInstancia.hide();
        } catch (e) { }
      }
    },

    obtenerNombreCompleto(cliente) {
      if (!cliente) return "";
      const partes = [cliente.nombre, cliente.apellido_paterno, cliente.apellido_materno].filter(Boolean);
      return partes.join(" ");
    },

    buscarClientes(pagina = 1) {
      this.cargando = true;
      this.paginaActual = pagina;
      this.busquedaRealizada = true;

      const params = {
        pagina: pagina,
        paginacion: true,
        activos: true
      };

      if (this.criterioBusqueda && this.criterioBusqueda.trim()) {
        params.dato_cliente = this.criterioBusqueda.trim();
      }

      ClienteSrv.clientesJSON(params)
        .then((response) => {
          const res = response?.data || {};
          let lista = res.clientes || [];
          lista = lista.map((c) => ({
            ...c,
            nombre_completo: this.obtenerNombreCompleto(c)
          }));
          this.clientes = lista;
          this.totalRegistros = res.total || lista.length;
          this.totalPaginas = res.ultima_pagina || (res.total ? Math.ceil(res.total / this.porPagina) : 1);
        })
        .catch((error) => {
          let msg = "No se pudieron cargar los clientes";
          try {
            msg = error.response.data.message || msg;
          } catch (e) { }
          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.error(msg);
          }
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    seleccionarYAsignar(cliente) {
      if (!this.chat) return;
      const idTelefono = this.chat.id || this.chat.id_telefono_cliente || this.chat.id_telefono;

      if (!idTelefono) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("No se encontró el identificador del teléfono para asignar");
        }
        return;
      }

      const nombreCliente = cliente.nombre_completo || this.obtenerNombreCompleto(cliente);

      const confirmar = () => {
        this.asignando = true;
        WhatsappSrv.asignarCliente(idTelefono, cliente.id)
          .then((response) => {
            const data = response?.data || {};
            if (typeof iu !== "undefined" && iu.msg) {
              iu.msg.success(data.message || "Cliente asignado correctamente");
            }
            this.$emit("cliente-asignado", {
              telefono: data.telefono_cliente || this.chat,
              cliente: data.cliente || cliente,
              id_telefono: idTelefono,
              id_cliente: cliente.id
            });
            this.cerrar();
          })
          .catch((error) => {
            let msg = "No se pudo asignar el cliente al teléfono";
            try {
              msg = error.response.data.message || msg;
            } catch (e) { }
            if (typeof iu !== "undefined" && iu.msg) {
              iu.msg.error(msg);
            }
          })
          .finally(() => {
            this.asignando = false;
          });
      };

      Swal.fire({
        title: "¿Asignar cliente?",
        text: `¿Desea asignar este número (${this.telefonoMostrar}) al cliente "${nombreCliente}"?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#008069",
        cancelButtonColor: "#74788d",
        confirmButtonText: '<i class="mdi mdi-check-bold me-1"></i> Sí, asignar',
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          confirmar();
        }
      });
    }
  }
};
</script>

<style scoped>
.modal-header .btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.table> :not(caption)>*>* {
  padding: 0.6rem 0.75rem;
}
</style>
